import { useState } from "react";

interface DialogProps {
    isOpen: boolean;
    title: string;
    message: string;
}

const useDialog = (): {
    isDialogOpen: boolean;
    dialogTitle: string;
    dialogMessage: string;
    openDialog: (title: string, text: string) => void;
    closeDialog: () => void;
} => {
    const [params, setParams] = useState<DialogProps>({ isOpen: false, title: "", message: "" });

    const closeDialog = (): void => {
        setParams({ ...params, isOpen: false });
    };

    const openDialog = (title: string, message: string): void => {
        setParams({ title, message, isOpen: true });
    };

    return {
        isDialogOpen: params.isOpen,
        dialogTitle: params.title,
        dialogMessage: params.message,
        openDialog,
        closeDialog,
    };
};

export default useDialog;
